module.exports = __webpack_public_path__ + "img/title_1.0687b0e3.png";